<h2>upp-side-menu — Side Navigation</h2>
<p class="demo-description">
    Visual composition of a reusable side menu using header, sections, and actions.
</p>

<div class="menu-demo-wrapper">
    <upp-side-menu>
        <upp-side-menu-header>
            <div class="side-menu-profile">
                <img class="avatar" src="assets/image/profile.png" alt="demo user">
                <div class="text">
                    <p class="title">Demo User</p>
                    <p class="subtitle">Demo Place</p>
                </div>
                <upp-side-menu-header-toggle icon="reorder-three-outline"></upp-side-menu-header-toggle>
            </div>
        </upp-side-menu-header>

        <upp-side-menu-content>
            <upp-side-menu-section title="Navigation">
                <upp-side-menu-action
                    icon="restaurant"
                    iconColor="success"
                    label="Orders"
                    [active]="selected === 'orders'"
                    (Clicked)="OnAction('orders')"
                ></upp-side-menu-action>
                <upp-side-menu-action
                    icon="wine-outline"
                    label="Products"
                    [active]="selected === 'products'"
                    (Clicked)="OnAction('products')"
                ></upp-side-menu-action>
                <upp-side-menu-action
                    icon="flower-outline"
                    label="Offers"
                    [active]="selected === 'offers'"
                    (Clicked)="OnAction('offers')"
                ></upp-side-menu-action>
            </upp-side-menu-section>

            <upp-side-menu-section title="Utilities">
                <upp-side-menu-action
                    icon="refresh-outline"
                    label="Reload"
                    (Clicked)="OnAction('reload')"
                ></upp-side-menu-action>
                <upp-side-menu-action
                    icon="help-circle-outline"
                    label="About"
                    (Clicked)="OnAction('about')"
                ></upp-side-menu-action>
            </upp-side-menu-section>
        </upp-side-menu-content>
    </upp-side-menu>
</div>
